import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import backgroundImg from './img/background.jpg'
import badgeImg from './img/badge.png'
import ovalImg from './img/oval.png'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSimplifiedName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro16">
      <div className="bp2-intro16mobile">
        <div className="bp2-fundo-layout-container">
          <img src={background || backgroundImg} className="bp2-fundo" />
        </div>
        <div className="bottom">
          <button className="button" type="button" onClick={onSkipIntro}>
            {buttonMessage}
          </button>
          <p
            className="warning"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
        </div>
        <div className="bp2-badge-layout-container">
          <div className="bp2-badge bp2-intro16-an-animation-enter ">
            <img src={badgeImg} className="bp2-badgem" />
            <img src={ovalImg} className="bp2-oval" />
          </div>
        </div>
        <div className="bp2-letrinhas notranslate">
          <div className="bp2-a bp2-intro16-an-animation-enter2 ">
            {coupleSimplifiedName.bride}
          </div>
          <div className="bp2-b bp2-intro16-an-animation-enter1 ">
            {coupleSimplifiedName.groom}
          </div>
        </div>
      </div>

      <div className="bp1-intro16desktop">
        <div className="bp1-fundo-layout-container">
          <img src={background || backgroundImg} className="bp1-fundo" />
        </div>
        <div className="bottom">
          <button className="button" type="button" onClick={onSkipIntro}>
            {buttonMessage}
          </button>
          <p
            className="warning"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
        </div>
        <div className="bp1-badge-layout-container">
          <div className="bp1-badge bp1-intro16-an-animation-enter ">
            <img src={badgeImg} className="bp1-badged" />
            <img src={ovalImg} className="bp1-oval" />
          </div>
        </div>
        <div className="bp1-letrinhas-layout-container">
          <div className="bp1-letrinhas notranslate">
            <div className="bp1-a bp1-intro16-an-animation-enter2 ">
              {coupleSimplifiedName.bride}
            </div>
            <div className="bp1-b bp1-intro16-an-animation-enter1 ">
              {coupleSimplifiedName.groom}
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
